import { z } from 'zod';

export const loadingStateSchema = z.object({
	patching: z.boolean(),
	changing_person_choice: z.boolean(),
	changing_main_product: z.boolean(),
	changing_date: z.boolean(),
	changing_product_filters: z.boolean(),
	validating_step: z.boolean(),
	validating_booking: z.boolean(),
	login: z.boolean(),
});

export type LoadingStoreState = z.infer<typeof loadingStateSchema>;
